import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ITaxNumbersResponse } from '../../models/tax-numbers.model';
import { selectTaxNumbers } from '../../selectors';
import { loadTaxNumbers, saveTaxNumber } from '../../actions/tax-numbers.actions';
import { IStaticDataCountriesResponse } from '../../../static-data/models/static-data-countries.model';
import { fromStaticDataCountrySelector } from '../../../static-data/selectors';
import { fromStaticDataCountriesActions } from '../../../static-data/actions';
import { SharedService } from '../../shared.service';

@Component({
  selector: 'app-tax-numbers',
  templateUrl: './tax-numbers.component.html',
  styleUrls: ['./tax-numbers.component.css']
})
export class TaxNumbersComponent implements OnInit {
  taxNumbers$: Observable<ITaxNumbersResponse | null>;
  @Input() customerId: string;
  /** When true (e.g. in product details), both member.edit and member.product.edit are required for Edit. When false (e.g. in employee details), only member.edit is required. */
  @Input() requireBothProductAndMemberEdit = false;
  staticDataCountries$: Observable<IStaticDataCountriesResponse[]>;
  staticDataCountries: any[];

  constructor(private store: Store,
    public sharedService: SharedService
  ) {}

  ngOnInit(): void {
    this.store.dispatch(loadTaxNumbers({ customerId: this.customerId }));
    this.taxNumbers$ = this.store.select(selectTaxNumbers);

    this.store.dispatch(fromStaticDataCountriesActions.loadStaticDataCountries({ noLoader: true}));
    this.staticDataCountries$ = this.store.select(fromStaticDataCountrySelector.getStaticDataCountriesResponse);
  }

  getCountryDisplayText(country) {
    return country.countryName;
  }

  onRowUpdating(event: any) {
    // Merge old and new data for partial updates
    const updatedTaxNumber = { ...event.oldData, ...event.newData };
    this.store.dispatch(saveTaxNumber({ customerId: this.customerId, taxNumber: updatedTaxNumber }));
  }
}